var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLogo = function SvgLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H13.1613H13.8065C13.8065 0.258065 13.8065 0.387098 13.8065 0.516131C13.8065 8.12906 13.8065 15.6129 13.8065 23.2259C13.8065 23.613 13.6775 23.742 13.2904 23.742C11.3549 23.742 9.54841 23.742 7.61293 23.742H7.09679V5.80647H0V0Z",
    fill: "#040721"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6649 18.1935C26.1811 18.1935 23.4714 15.3548 23.4714 11.9999C23.4714 8.51605 26.3101 5.80636 29.6649 5.80636C31.8585 5.80636 33.794 6.96765 34.8262 8.64508L38.1811 3.87087C35.9875 1.67732 33.0198 0.257957 29.6649 0.257957C23.0843 0.257957 17.7939 5.5483 17.7939 12.129C17.7939 18.7096 23.0843 24 29.6649 24C33.1488 24 36.1166 22.5806 38.3101 20.258L34.9553 15.0967C33.923 16.9032 31.8585 18.1935 29.6649 18.1935Z",
    fill: "#F9DA87"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.cab93624e3386c7c7d6755c00eccec69.svg";